<template>
  <v-container>
    <base-material-card color="secondary" icon="mdi-credit-card-outline" :title="$t('affiliation')">
      <v-container>
        <v-row v-if="RBAC_TESSERATE_OTHER_USER && RBAC_USER_VIEW_OTHER_USER">
          <v-autocomplete v-model="masterId" :items="selectUsers" item-text="text" item-value="value" @change="resetForm"
            dense :label="$t('select_user')"></v-autocomplete>
        </v-row>
        <v-stepper v-model="stepper">
          <v-stepper-header>
            <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{ $t("confirm_profile_data")
            }}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :step="2" :editable="stepper >= 2" :complete="stepper > 2">{{ $t("select_affiliation_card")
            }}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :step="3" :editable="stepper >= 3 && typeof idProduct !== 'undefined'"
              :complete="stepper > 3 && typeof idProduct !== 'undefined'">{{ $t("select_gift") }}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :step="4" :editable="stepper >= 4" :complete="stepper > 4">{{ $t("accept_condition")
            }}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :step="5" :editable="stepper >= 5" :complete="stepper > 5">{{ $t("exec_payment")
            }}</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1">
              <user-edit-profile :paramsMasterId="masterId" paramsMode="EDIT" paramsType="plain" :paramsIfConfirm="true"
                @isUpdated="confirmData"></user-edit-profile>
            </v-stepper-content>
            <v-stepper-content :step="2">
              <list-tessere :auth="true" :masterId="masterId" @selected="selectTessera" :upgrade="true"></list-tessere>
            </v-stepper-content>
            <v-stepper-content :step="3">
              <product-configuration :setQtaMax="1" :viewPrice="false" :idProduct="idProduct"
                @configured="configureProduct" :upgrade="true"></product-configuration>
            </v-stepper-content>
            <v-stepper-content :step="4">
              <accept-condition v-if="tessera" :idTessera="tessera.tesId" @confirmed="confirmTerms"></accept-condition>
            </v-stepper-content>
            <v-stepper-content :step="5">
              <select-mod-pag v-if="tessera" :tesId="tessera.tesId" :riepilogo="riepilogo" @selected="confirmOrder"
                :usePoint="tessera.buyWithCredits === 1"></select-mod-pag>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import userEditProfile from "@/widget/userEditProfile.vue";
import listTessere from "@/widget/listTessere.vue";
import productConfiguration from "@/widget/productConfiguration.vue";
import acceptCondition from "@/widget/acceptCondition.vue";
import selectModPag from "@/widget/selectModPag.vue";

export default {
  name: "tesseramento",
  components: {
    userEditProfile,
    listTessere,
    acceptCondition,
    selectModPag,
    productConfiguration,
  },
  data() {
    return {
      masterId: null,
      stepper: 1,
      tessera: null,
      idProduct: null,
      qualifica: null,
      discipline: [],
      selectUsers: [],
      confirmedCondition: null,
      productConfig: null,
      pagId: null,
      dataPag: null,
      riepilogo: {
        headers: [
          { text: this.$t("item"), value: "item" },
          { text: this.$t("option"), value: "selectedOptions" },
          { text: this.$t("price"), value: "prezzo" },
        ],
        items: [],
        totale: 0,
      },
      RBAC_TESSERATE_OTHER_USER: false,
      RBAC_USER_VIEW_OTHER_USER: false,
    };
  },
  created() {
    this.RBAC_TESSERATE_OTHER_USER = this.checkUserRole(
      "tesseramenti",
      "TESSERATE_OTHER_USER"
    );
    this.RBAC_USER_VIEW_OTHER_USER = this.checkUserRole(
      "user",
      "VIEW_OTHER_USER"
    );
    if (this.RBAC_TESSERATE_OTHER_USER && this.RBAC_USER_VIEW_OTHER_USER) {
      let url = "/auth/portal/listUsers";
      let filter = { filter: { type: "tutti" } };
      let _ = this;
      _.selectUsers = [];
      this.chiamataAxios("POST", url, { body: filter }).then((response) => {
        _.selectUsers = response.data.map(function (item) {
          return {
            value: item.masterId,
            text:
              item.surname +
              " " +
              item.name +
              "   -   " +
              item.resCity +
              " (" +
              item.eta +
              " anni)",
          };
        });
      });
      if (this.$route.params.masterId)
        this.masterId = parseInt(this.$route.params.masterId);
      else this.masterId = myData.masterId;
    } else {
      this.masterId = myData.masterId;
    }
  },
  methods: {
    confirmData() {
      this.stepper = 2;
      this.$globalHandler.scroll.toTop = true;
    },
    resetForm() {
      this.stepper = 1;
      this.tessera = null;
      this.idProduct = null;
      this.discipline = [];
      this.confirmedCondition = null;
      this.productConfig = null;
    },
    confirmOrder(pagamento) {
      this.dataPag = pagamento.dataPag;
      this.pagId = pagamento.pagId;

      let data = {
        tessera: this.tessera,
        idProduct: this.idProduct,
        productConfig: this.productConfig,
        discipline: this.discipline,
        qualifica: this.qualifica,
        pagId: this.pagId,
        dataPag: this.dataPag,
        usePoint: pagamento.selectedPoint,
      };
      let _ = this;
      let url =
        "/auth/tesseramenti/tesseramento/" +
        this.masterId +
        "/" +
        this.tessera.tesId;
      this.chiamataAxios("POST", url, { body: data, dialogLoader: true }).then(
        (response) => {
          _.$updateCrediti.updateCreditiRsp.updated = new Date();
          if (response.data.payUrl) {
            Swal.fire({
              title: _.$t("redirect_to_external_site"),
              html: _.$t("for_complete_the_payment_operation"),
            }).then((result) => {
              window.open(response.data.payUrl);
            });
          } else {
            Swal.fire({
              type: response.msg.esito ? "success" : "error",
              title: response.msg.esito
                ? _.$t("operation_successfully_completed")
                : _.$t("there_was_an_error"),
              html: response.msg.msgTxt,
            });
          }
          if(response.msg.esito) _.$router.push("/portal/");
        }
      );
    },
    selectTessera(tessera) {
      this.tessera = tessera;
      this.idProduct = tessera.idProduct;
      if (!this.idProduct) this.stepper = 4;
      else this.stepper = 3;
    },
    configureProduct(configured) {
      this.productConfig = configured;
      this.stepper = 4;
    },
    confirmTerms(confirmed) {
      let _ = this;
      _.confirmedCondition = confirmed.confirmed;
      _.discipline = confirmed.discipline;
      _.qualifica = confirmed.qualifica;

      // Prepara riepilogo
      _.riepilogo.items = [];
      _.riepilogo.totale = _.tessera.prezzo ? _.tessera.prezzo : 0;
      _.riepilogo.items.push({
        item: _.tessera.title,
        selectedOptions: "",
        prezzo: _.tessera.prezzo,
      });
      if (this.idProduct && _.productConfig) {
        let options = [];

        for (var key in _.productConfig.selectedConfiguration[0].options) {
          // check if the property/key is defined in the object itself, not in parent
          if (
            _.productConfig.selectedConfiguration[0].options.hasOwnProperty(key)
          ) {
            options.push(
              key + ": " + _.productConfig.selectedConfiguration[0].options[key]
            );
          }
        }

        _.riepilogo.items.push({
          item: _.productConfig.title,
          selectedOptions: options.join(", "),
          prezzo: 0,
        });
      } else {
        _.productConfig = null;
      }
      this.stepper = 5;
    },
  },
};
</script>